import React, { useEffect } from 'react';
import { BsInstagram } from 'react-icons/bs';
import styled from 'styled-components';

// Tarjeta de respaldo por si todavía no se cargó un link de publicación válido
const FallbackCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  padding: 2rem;
  text-decoration: none;
  color: #066a67;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);

  svg {
    font-size: 2rem;
    color: #18776a;
  }
`;

const EmbedWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .instagram-media {
    margin: 0 auto !important;
  }
`;

// Detecta si la URL apunta a una publicación / reel concreto
const isPostUrl = (url) => /instagram\.com\/(p|reel|tv)\//i.test(url || '');

const InstagramEmbed = ({ url }) => {
  useEffect(() => {
    if (!isPostUrl(url)) return;

    const process = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    const existing = document.getElementById('instagram-embed-script');
    if (!existing) {
      const script = document.createElement('script');
      script.id = 'instagram-embed-script';
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.onload = process;
      document.body.appendChild(script);
    } else {
      process();
    }
  }, [url]);

  // Si aún no hay un link de publicación válido, mostramos la tarjeta clásica
  if (!isPostUrl(url)) {
    return (
      <FallbackCard href={url || 'https://www.instagram.com/radixagro/'} target="_blank" rel="noreferrer">
        <BsInstagram />
        <strong>@radixagro</strong>
        <span>Seguinos en Instagram</span>
      </FallbackCard>
    );
  }

  return (
    <EmbedWrapper>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{
          background: '#fff',
          border: 0,
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          margin: 0,
          padding: 0,
          width: '100%',
          maxWidth: '540px',
        }}
      >
        <a href={url} target="_blank" rel="noreferrer">
          Ver esta publicación en Instagram
        </a>
      </blockquote>
    </EmbedWrapper>
  );
};

export default InstagramEmbed;
